<template>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat ref="scroll_target" class="scroll-y" :max-height="calcScroll(64+2, 56+2)">
          <v-toolbar dense flat >
            <v-toolbar-title>Журнал операций
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container
            fluid
            style="min-height: 0; margin-top: "
          >
            <v-action-logs-panel :topCount="5"></v-action-logs-panel>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vActionLogsPanel from './ActionLogsPanel'

  export default {
    name: 'action-log-page',
    components: {vActionLogsPanel},
    data: () => ({
    }),
    mounted () {
    },
    computed: {
      ...mapGetters({
        calcScroll: 'calcScroll'
      })
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// ActionLogPage.vue?45db2468